export default {"separator":"@","parallelPages":{}}